import {
  computeNativeReviewsCount,
  computeNativeReviewsAverage
} from '../../centerReviews/centerReviews'

const addNativeReviewsCountToCenter = (center, nativeReviews) => {
  const review_average = computeNativeReviewsAverage(nativeReviews)
  const review_count = computeNativeReviewsCount(nativeReviews)

  return {
    ...center,
    review_average,
    review_count
  }
}

export default addNativeReviewsCountToCenter
